'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MilanoteLogotype = require('../../../components/icons/MilanoteLogotype');

var _MilanoteLogotype2 = _interopRequireDefault(_MilanoteLogotype);

var _AnchorButton = require('../../../components/buttons/AnchorButton');

var _AnchorButton2 = _interopRequireDefault(_AnchorButton);

var _urlConstants = require('../../../../common/utils/urlConstants');

var _notificationConstants = require('../../../../common/notifications/notificationConstants');

require('./MarketingModalFooter.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MarketingModalFooter = function MarketingModalFooter(props) {
    return _react2.default.createElement(
        'footer',
        { className: 'MarketingModalFooter' },
        _react2.default.createElement(
            'div',
            { className: 'content' },
            _react2.default.createElement(
                'ul',
                { className: 'links' },
                _react2.default.createElement(
                    'li',
                    { className: 'group' },
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            { className: 'group-header' },
                            'Want to know more?'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: _urlConstants.BLOG_URL },
                                'Milanote blog'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: _urlConstants.MARKETING_PLANS_URL },
                                'Plans & pricing'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: _urlConstants.HELP_URL },
                                'Help centre'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: _urlConstants.MARKETING_POLL_URL },
                                'Upcoming features'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'li',
                    { className: 'group' },
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            { className: 'group-header' },
                            'Follow @milanoteapp'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: 'https://twitter.com/milanoteapp' },
                                'Twitter'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: 'https://www.facebook.com/milanoteapp' },
                                'Facebook'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: 'https://www.instagram.com/milanoteapp' },
                                'Instagram'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'li',
                    { className: 'group' },
                    _react2.default.createElement(
                        'a',
                        { href: _urlConstants.MARKETING_URL + '/milanote-press-kit.zip' },
                        'Download press kit'
                    )
                ),
                _react2.default.createElement(
                    'li',
                    { className: 'group' },
                    _react2.default.createElement(
                        'a',
                        { href: 'mailto:' + _notificationConstants.MILANOTE_EMAILS.INFO },
                        _notificationConstants.MILANOTE_EMAILS.INFO
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'logo' },
                _react2.default.createElement(
                    _AnchorButton2.default,
                    { className: 'home-link', href: _urlConstants.MARKETING_URL },
                    _react2.default.createElement(_MilanoteLogotype2.default, { className: 'center' })
                )
            )
        )
    );
};

exports.default = MarketingModalFooter;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/modal/marketingModalPage/MarketingModalFooter.js
// module id = 1922
// module chunks = 0